import React, { useCallback, useMemo } from 'react';
import { IFriend } from '../../../../interfaces/friend.interface';
import { Box, Typography } from '@mui/material';
import SenderInfo from '../ChatHeader/SenderInfo';
import IconWithBackground from '../../../../components/MUIComponents/IconWithBackground';
import CheckIcon from '../../../../components/Icons/CheckIcon';

interface ChatSuggestionsListProps {
  friends: IFriend[];
  onClick: (friend: IFriend) => void;
  selectedFriends?: IFriend[];
}

const ChatSuggestionsList = ({
  friends,
  onClick,
  selectedFriends = [],
}: ChatSuggestionsListProps) => {
  const isUserAlreadySelected = useCallback(
    (userId: string) => selectedFriends.some(u => u.userId === userId),
    [selectedFriends]
  );

  const hasFriends = useMemo(() => friends && friends?.length > 0, [friends]);

  return (
    <Box sx={mainStyles}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.75rem',
          padding: '1.75rem 1rem',
        }}
      >
        <Typography variant="body3" fontWeight={700} color={'text.primary'}>
          {hasFriends ? 'Suggestions for you' : 'No suggestions yet'}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
          {friends?.map((friend, index) => (
            <Box
              key={index}
              onClick={() => onClick(friend)}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.375rem',
                '&:hover': { bgcolor: 'background.light', cursor: 'pointer' },
              }}
            >
              <SenderInfo
                firstname={friend.firstName}
                lastname={friend.lastName}
                avatar={friend.avatarUrl}
                sports={friend.sports}
              />

              {isUserAlreadySelected(friend.userId) && (
                <IconWithBackground
                  icon={<CheckIcon />}
                  size={'2.5rem'}
                  bgcolor={'stepperConnector.light'}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const mainStyles = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  borderBottom: '1px solid',
  borderColor: 'background.dark',
  overflow: 'scroll',
  scrollbarWidth: 'none',
};

export default ChatSuggestionsList;
